import React from "react";
import { Autocomplete, AutocompleteProps } from "@mantine/core";

import styles from "@scss/custom-components/form-fields-dropdowns.module.scss";

interface CustomAutocompleteProps extends AutocompleteProps {}

export const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({
  variant = "default",
  classNames = {},
  ...props
}) => {
  const variantDropdownClasses: Record<string, string> = {
    default: styles["dropdown--default"],
    dark: styles["dropdown--dark"],
    darker: styles["dropdown--darker"],
    sky: styles["dropdown--sky"],
  };

  const customDropdownClass = variantDropdownClasses[variant] || "";

  return (
    <Autocomplete
      variant={variant}
      classNames={{
        ...classNames,
        dropdown: customDropdownClass,
        options: styles.options,
        option: styles.option,
      }}
      {...props}
    />
  );
};
